import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import KycWizard, { KycHeader } from "@/components/kyc/KycWizard";
import DigioKycFlow from "@/components/kyc/DigioKycFlow";
import TruidKycFlow from "@/components/kyc/TruidKycFlow";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function KycPage() {
  const { user } = useAuth();
  const [mode, setMode] = useState(null);

  useEffect(() => {
    api
      .get("/api/kyc/mode")
      .then(({ data }) => setMode(data))
      .catch(() => setMode({ kyc_mode: "manual" }));
  }, []);

  const autoVendor = mode?.auto_kyc_vendor || "truid";

  return (
    <AppShell>
      {!mode ? (
        <div className="space-y-5">
          <KycHeader status={user?.kyc_status} />
          <div className="skeleton h-64 w-full" />
        </div>
      ) : mode.kyc_mode === "auto" ? (
        <div className="space-y-6">
          <KycHeader
            status={user?.kyc_status}
            subtitle={
              autoVendor === "truid"
                ? "Auto KYC: DigiLocker Aadhaar → PAN Detailed → Face Match."
                : "Instant Aadhaar and PAN verification through DigiLocker."
            }
          />
          {autoVendor === "truid" ? <TruidKycFlow /> : <DigioKycFlow />}
        </div>
      ) : mode.kyc_mode === "disabled" ? (
        <div className="space-y-6">
          <KycHeader status={user?.kyc_status} />
          <div className="rounded-xl border border-border bg-surface/50 p-5 text-sm text-muted-foreground">
            KYC verification is currently disabled. Contact support.
          </div>
        </div>
      ) : (
        <KycWizard faceMatchRequired={mode.face_match_required} />
      )}
    </AppShell>
  );
}
